import type { membershipApi } from 'app/src/services/welfareportal'

// eslint-disable-next-line import/no-named-as-default
import z from 'zod'

export const userMembershipSchema: z.ZodType<membershipApi.UserMembership> = z.object({
  membershipId: z.string(),
  campaignName: z.string(),
  active: z.boolean(),
  campaignId: z.string(),
  campaignDateFrom: z.string(),
  campaignDateTo: z.string(),
})

export const documentSchema = z.object({
  documentId: z.string(),
  name: z.string(),
  url: z.string(),
  type: z.string().max(255),
  body: z.string().optional(),
  title: z.string().optional(),
})

export const spendingReminderSchema = z.object({
  ranges: z.array(
    z.object({
      from: z.number(),
      to: z.number(),
      msgKey: z.string(),
    }),
  ),
  thresholdDays: z.string(),
})

export const funnel: z.ZodType<membershipApi.Funnel> = z.enum(['DIRECT', 'PRIZE', 'REFUND', 'TRANSFER', 'DISCOUNT'])

export const configurationSchema: z.ZodType<membershipApi.CompanyWelfareConfiguration> = z.object({
  fringeWarningThreshold: z.number().optional(),
  familyMembersRelations: z.array(
    z.enum([
      'coniuge',
      'fratello_sorella',
      'figlio_figlia',
      'genero_nuora',
      'suocero_suocera',
      'genitore',
      'genitore_convivente',
      'genitore_percettore',
    ]),
  ),
  familyMemberPrivacyDocument: z.boolean(),
  funnels: z.array(funnel),
  backofficeFunnels: z.array(funnel).optional(),
  frontend: z.object({
    templateId: z.string(),
    companyLogoPath: z.string(),
    cssPath: z.string(),
    contactInfo: z
      .object({
        email: z.string().optional(),
        phone: z.string().optional(),
      })
      .optional(),
  }),
  joinConfig: z
    .object({
      choiceMode: z.enum(['combo', 'slider', 'input']).optional(),
      joinPercentages: z.array(z.number()).optional(),
    })
    .optional(),
  spendingReminder: spendingReminderSchema.optional(),
})

export const welfareCampaignSchema: z.ZodType<membershipApi.CompanyWelfareCampaign> = z.object({
  campaignName: z.string(),
  companyCode: z.string(),
  companyName: z.string(),
  campaignId: z.string(),
  mustJoin: z.boolean(),
  joinDateFrom: z.string(),
  joinDateTo: z.string(),
  fruitionDateFrom: z.string(),
  fruitionDateTo: z.string(),
  phase: z.enum(['join', 'fruition', 'pre-join', 'pre-fruition', 'closed']),
  documents: z.array(documentSchema),
  configuration: configurationSchema,
})

export const userWelfareMode: z.ZodType<membershipApi.UserWelfareMode> = z.enum(['join', 'fruition', 'readonly'])

export const userInfoSchema: z.ZodType<membershipApi.UserInfo> = z.object({
  tenantId: z.string(),
  userId: z.string(),
  email: z.string().email(),
  firstName: z.string(),
  lastName: z.string(),
  userWelfareMode: userWelfareMode,
  userMemberships: z.array(userMembershipSchema),
  welfareCampaign: welfareCampaignSchema,
  services: z.object({
    mealVouchers: z.boolean(),
  }),
})
